import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import { palette } from "../../../styles/theme";
import { resolveSpecsImageUrl } from "../specsAssetUrls";
import { canPreviewImageUrl } from "../specsEditorUtils";
import { SpecsAssetImage } from "./SpecsAssetImage";

export function SpecsImageUrlPreviewButton({
  src,
  alt = "Image preview",
}: {
  src?: string | null;
  alt?: string;
}) {
  const resolvedSrc = resolveSpecsImageUrl(src);
  const previewable = canPreviewImageUrl(resolvedSrc);
  const [open, setOpen] = useState(false);

  if (!previewable) {
    return null;
  }

  return (
    <>
      <Tooltip title="Voir l'image">
        <Box
          component="button"
          type="button"
          aria-label="Voir l'image"
          onClick={(event) => {
            event.stopPropagation();
            setOpen(true);
          }}
          onMouseDown={(event) => event.stopPropagation()}
          sx={{
            width: 24,
            height: 24,
            p: 0,
            borderRadius: "4px",
            overflow: "hidden",
            border: `1px solid ${palette.grey.lightGrey}`,
            bgcolor: palette.grey.lightBackground,
            cursor: "pointer",
            flexShrink: 0,
          }}
        >
          <SpecsAssetImage
            src={resolvedSrc}
            alt={alt}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>
      </Tooltip>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Image</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: "100%",
              minHeight: 320,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: palette.grey.lightBackground,
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <SpecsAssetImage
              src={resolvedSrc}
              alt={alt}
              sx={{
                maxWidth: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            component="a"
            href={resolvedSrc}
            download
            size="small"
            onMouseDown={(event) => event.stopPropagation()}
            onClick={(event) => event.stopPropagation()}
          >
            Télécharger
          </Button>
          <Button onClick={() => setOpen(false)} size="small">
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
